var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 440.759,
    viewBox: "0 0 400 440.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11392",
    "data-name": "Path 11392",
    d: "M43.961,109.375c-23.8,28.129-21.1,78.439-11.358,118.8,9.848,40.462,26.835,71.1,50.636,107.672s54.395,79.177,94.884,89.026,90.671-13.167,134.812-49.742,82.34-86.912,92.507-147.281c10.16-60.484-7.572-131.134-51.719-159.262s-114.79-13.743-175.274-3.569C118.079,75.293,67.768,81.246,43.961,109.375Z",
    transform: "translate(-25.489 -16.834)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11393",
    "data-name": "Path 11393",
    d: "M277.425,201.69c.921,4.5-.081,36.751,1.253,41.837s16.14,67.25,16.14,67.25l-23.55-6.509s-8.256-18.145-11.25-34.482C257.383,255.407,257.763,201.941,277.425,201.69Z",
    transform: "translate(-70.146 -65.084)",
    fill: "#ffcaad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11394",
    "data-name": "Path 11394",
    d: "M215.31,206.9h15.28l8.751-33.188H224.054Z",
    transform: "translate(14.828 -56.055)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_311",
    "data-name": "Ellipse 311",
    cx: 16.73,
    cy: 16.73,
    r: 16.73,
    transform: "translate(150.798 259.524)",
    fill: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9965",
    "data-name": "Group 9965",
    transform: "translate(32.255 243.127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 166.015,
    height: 166.016,
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9964",
    "data-name": "Group 9964",
    transform: "translate(14.014 25.955)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 84.819,
    transform: "translate(47.52)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.04
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 37.604,
    transform: "translate(47.52 14.338)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.04
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 84.819,
    transform: "translate(47.52 49.883)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.04
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 37.604,
    transform: "translate(47.52 64.223)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.04
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 84.819,
    transform: "translate(47.52 99.76)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.04
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 37.604,
    transform: "translate(47.52 114.098)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 16.73,
    cy: 16.73,
    rx: 16.73,
    ry: 16.73,
    transform: "translate(0 40.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_313",
    "data-name": "Ellipse 313",
    cx: 16.73,
    cy: 16.73,
    rx: 16.73,
    ry: 16.73,
    transform: "translate(0 90.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 16.73,
    cy: 16.73,
    rx: 16.73,
    ry: 16.73,
    transform: "translate(0 -7.68)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11395",
    "data-name": "Path 11395",
    d: "M89.317,585.278,73.705,576.29,63.83,594.374l18.186,8.981Z",
    transform: "translate(267.45 -185.964)",
    fill: "#ffd8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11396",
    "data-name": "Path 11396",
    d: "M257.533,573.3l-3.481,19.987-21.112-3.59L239.9,567.01Z",
    transform: "translate(-15.305 -182.969)",
    fill: "#ffd8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11397",
    "data-name": "Path 11397",
    d: "M146.418,341.25c6.218.339,108.241,22.493,109.568,27.688,10.925,42.616-51.475,132.075-56.061,134.784-4.944-1.192-21.816-7.071-21.816-7.071L181.984,437Z",
    transform: "translate(43.562 -110.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11398",
    "data-name": "Path 11398",
    d: "M0,592.519,12.462,566.47l33.913-32.45,8.758,4.822L21.559,603.187Z",
    transform: "translate(344.867 -172.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11399",
    "data-name": "Path 11399",
    d: "M174.621,593.43l28.433,5.066,40.327,24.024-2.323,9.733-70.968-15.2Z",
    transform: "translate(41.415 -191.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11400",
    "data-name": "Path 11400",
    d: "M91.1,302.23c-3.969,3.177-8.128,17.495-8.609,22.351-5.195,56.339,87.535,89.513,100.377,95.081C195.065,429.855,301.4,508.247,307.884,510.1s17.082-23.029,16.154-26.354-156.784-160-156.784-160Z",
    transform: "translate(20.172 -97.527)",
    fill: "#0a0909"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11401",
    "data-name": "Path 11401",
    d: "M280.515,152.125c13.119-6.482,25.25,29.07,24.085,33.141s-13.208,5.236-16.255,5.236S280.515,152.125,280.515,152.125Z",
    transform: "translate(-94.674 -48.835)",
    fill: "#e0d21d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11402",
    "data-name": "Path 11402",
    d: "M340.528,122.39c-47.886,0-52.4,114.16-51.862,121.95,4.836,15.876,62.841,34.949,80.695,24.512C397.693,202.421,384.641,122.39,340.528,122.39Z",
    transform: "translate(-179.842 -39.494)",
    fill: "#ffec02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11403",
    "data-name": "Path 11403",
    d: "M227.557,205.49c-2.675,4.565-8.432,34.312-7.857,38.193s9.482,13.675,12.652,13.892c45.068,3.061,93.95-14.948,103.086-20.008,19.114-1.524,30.425-8.426,30.425-18.518,0-5.96-3.305-10.254-5.127-10.254-3.454,0-9.591,5.954-10.336,7.694,1.49-3.061,6.164-8.683,2.316-8.683-1.07,0-9.753,12.137-14.467,15.084s-72.75,5.418-86.391,10.376c1.741-3.468,6.617-16.039,6.7-17.854S227.557,205.49,227.557,205.49Z",
    transform: "translate(-114.641 -66.31)",
    fill: "#ffd8c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 36.385,
    height: 36.385,
    rx: 7.68,
    transform: "translate(269.302 105.358) rotate(-168.76)",
    fill: "#77b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11404",
    "data-name": "Path 11404",
    d: "M209.185,114.058l-.7-3.475a2.653,2.653,0,0,0-3.128-2.091l-1.929,8.532,1.906,9.574,9.847-1.952a1.772,1.772,0,0,0,1.448-1.825l-.353-8.109a1.778,1.778,0,0,0-1.859-1.691,2.374,2.374,0,0,0-.284.035Zm-3.846,12.528-2.612.521a1.772,1.772,0,0,1-2.085-1.4l-1.216-6.093a1.778,1.778,0,0,1,1.4-2.091l2.612-.516",
    transform: "matrix(0.921, 0.391, -0.391, 0.921, 109.469, -105.401)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11405",
    "data-name": "Path 11405",
    d: "M215.35,158.213l-3.17-9.333,9.672,1.924Z",
    transform: "translate(34.437 -48.042)",
    fill: "#77b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11406",
    "data-name": "Path 11406",
    d: "M394.8,135.432c-20.732-7.6-37.123,40.3-36.453,46.369s33.865,16.7,37.6,14.5S415.354,142.963,394.8,135.432Z",
    transform: "translate(-247.888 -43.44)",
    fill: "#f0df09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11407",
    "data-name": "Path 11407",
    d: "M329.914,91.72c.224,2.879-1.531,18.965-4.274,24.214,1.212,2.384,13.675,9.313,19.642,7.83.813-4.457,2.973-16.425,4.741-20.069C346.833,102.029,329.914,91.72,329.914,91.72Z",
    transform: "translate(-170.582 -29.597)",
    fill: "#ffcaad"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 27.187,
    cy: 34.076,
    rx: 27.187,
    ry: 34.076,
    transform: "translate(200.923 83.059) rotate(-165.14)",
    fill: "#ffd8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11408",
    "data-name": "Path 11408",
    d: "M269.2,42.7c1.5.081,7.24-2.845,8.514-11.623,4.138-.677,22.385,1.267,31.949,8.805a28.453,28.453,0,0,0,11.772,2.486,5.126,5.126,0,0,0,4.694-4.477c0-5.019-2.154-9.882-8.446-10.207,5.3-.115,10.207-3.387,10.207-5.8,0-3.2-7.281-13.031-19.981-8.724,2.98-2.154,6.346-4.254,6.346-6.292,0-3.488-5.019-6.875-13.8-6.875-13.58,0-28.379,5.628-31.576,9.658-1.49-.772-3.387-2.208-7.017-2.208-9.049,0-12.083,29.314-8.168,39.142a8.6,8.6,0,0,0,3.19,1.239",
    transform: "translate(-98.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11409",
    "data-name": "Path 11409",
    d: "M351.262,61.871a6.685,6.685,0,1,0-3.387,8.229",
    transform: "translate(-180.376 -18.523)",
    fill: "#ffcaad"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientMain);
export default __webpack_public_path__ + "static/media/client-main.8ab4078d2f1984240798b4c4f8c3c94a.svg";
export { ForwardRef as ReactComponent };